/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {CancelService} from "../../services/cancel.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ExternalEvidenceStatus} from "../../constant/external-evidence-status";
import {EvidenceTemplates} from "../../constant/evidence-templates";
import {TranslateService} from "@ngx-translate/core";
import {ExternalEvidenceTempDataStatus} from "../../constant/external-evidence-temp-data-status";
import {CustomErrors} from "../../constant/custom-errors";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ImagePreviewPopupComponent} from "../image-preview-popup/image-preview-popup.component";
import {SharedService} from "../../services/shared.service";
import {ExternalEvidencePartStatus} from "../../constant/external-evidence-part-status";
import {ActivatedRoute} from "@angular/router";
import {RootScopeService} from "../../services/rootscope.service";
import {Steps} from "../../constant/steps";
import {SignerService} from "../../services/signer.service";
import {SessionService} from "../../services/session.service";
import {RedirectionService} from "../../services/redirection.service";
import {SignerDto} from "../../model/signerDto";
import {ExternalSessionStatus} from "../../constant/external-session-status";
import {EvidenceUserHelperService} from "../../services/evidence-user-helper.service";
import {HttpService} from "../../http/http.service";
import ExternalSignerStatusEnum = SignerDto.ExternalSignerStatusEnum;

@Component({
    selector: 'app-evidences',
    templateUrl: './evidences.component.html'
})
export class EvidencesComponent implements OnInit {

    constructor(public signerService: SignerService,
                private sessionService: SessionService,
                private redirectionService: RedirectionService,
                private cancelService: CancelService,
                private route: ActivatedRoute,
                private spinnerService: NgxSpinnerService,
                private translateService: TranslateService,
                private modalService: NgbModal,
                private sharedService: SharedService,
                private rootScope: RootScopeService,
                private evidenceUserHelperService: EvidenceUserHelperService,
                private http: HttpService) {
    }

    errorMsg: any;
    spinneractive = false;

    infoBoxMsg: any
    infoBoxDetails: any

    evidencesWithTemp: any
    templateToUse: EvidenceTemplates = EvidenceTemplates.NONE
    numberToUpload: any
    onHoldAvailability: any
    onHoldLimitReached: any
    nbPages: any
    evidenceToCrop: any
    buttonDisabled: any
    //manage slider for analys results
    slides: any[] = [];

    private externalEvidenceTempDataStatus: any
    private currentSigner: any
    // Check the sessionId
    private sessionId = this.route.snapshot.params['sessionId'];
    private slidestemp: any[] = [];
    private currentImage: any

    ngOnInit(): void {
        const that = this;

        this.rootScope.get().step = Steps.evidences;
        //Pass enum to the scope
        this.externalEvidenceTempDataStatus = ExternalEvidenceTempDataStatus;

        this.currentSigner = this.signerService.currentSigner;
        //Set default description
        this.infoBoxMsg = 'evidences.description';

        //Set popover table
        if (typeof (this.rootScope.get().popoverTable) === 'undefined') {
            this.evidenceUserHelperService.createPopoverTable();
        }

        //Update popover status on popoverTable
        this.rootScope.get().openPopover = function (helpButtonId) {
            that.evidenceUserHelperService.changePopoverStatus(helpButtonId);
        };

        if (this.sessionId !== this.sessionService.id) {
            console.warn('The session ID in the url is not the same as the saved : url->' + this.sessionId + ' | saved->' + this.sessionService.id);
            this.redirectionService.session(this.route, this.sessionId);
            return;
        }

        // Check the status of the session
        if (typeof this.sessionService.info === 'undefined' || this.sessionService.info.externalSessionStatus !== ExternalSessionStatus.init) {
            console.warn('The current signer is undefined or is not at the init status');
            this.redirectionService.session(this.route, this.sessionId);
            return;
        }

        // Check the status of the signer
        if (typeof this.signerService.currentSigner === 'undefined' || this.signerService.currentSigner.externalSignerStatus !== ExternalSignerStatusEnum.Evidences) {
            console.warn('The current signer is undefined or is not at the agreements status');
            this.redirectionService.session(this.route, this.sessionId);
            return;
        }

        console.debug('The context is OK.');

        this.spinneractive = false;
        this.sharedService.on('us-spinner:spin', function () {
            that.spinneractive = true;
        });
        this.sharedService.on('us-spinner:stop', function () {
            that.spinneractive = false;
        });


        this.spinneractive = false;
        this.sharedService.on('us-spinner:spin', function () {
            that.spinneractive = true;
        });
        this.sharedService.on('us-spinner:stop', function () {
            that.spinneractive = false;
        });

        // Enable spin
        this.spinnerService.show('spinner');

        console.debug('Getting all evidences.');
        this.http.getAllWithTemp(this.sessionId, this.signerService.currentSigner.extSignerId).toPromise()
            .then(function (response) {

                // Disable the spin
                that.spinnerService.hide('spinner');

                if (response?.success) {

                    if ((response.result as []).length > 0) {
                        that.evidencesWithTemp = response.result;
                        if (that.evidenceAnalysisToValidate()) {
                            that.infoBoxMsg = 'evidence.analysis.maxTryReached';
                            that.templateToUse = EvidenceTemplates.EVIDENCES_TEMPLATE_ANALYSE
                            that.loadSlide();
                            console.debug('Evidence analysis have evidence to be validate');
                        } else {
                            if (that.evidenceAnalysisInProgress()) {
                                that.goToNextStep();
                            } else if (that.evidenceAnalysisError()) {
                                console.debug('Evidence analysis still in progress or error');
                                that.infoBoxMsg = 'evidence.analysis.error';
                                that.templateToUse = EvidenceTemplates.EVIDENCES_TEMPLATE_ANALYSE;
                                that.loadSlide();

                            } else if (that.evidenceUploadInProgress()) {
                                that.evidencesWithTemp.forEach(evidenceWithTemp => {
                                    //One evidence has an analysis in progress
                                    if (evidenceWithTemp.evidenceTempDataDto) {
                                        if (evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus !== ExternalEvidenceTempDataStatus.AFFECTED) {
                                            if (evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.AFFECTATION) {
                                                that.infoBoxMsg = 'affectation.description';
                                            } else if (evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.TO_CROP_AND_AFFECTATION) {
                                                that.infoBoxMsg = 'cropping.dispatch.description';
                                            } else if (evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.TO_CROP) {
                                                that.infoBoxMsg = 'cropping.description';
                                            }
                                            that.templateToUse = EvidenceTemplates.EVIDENCES_TEMPLATE_CROPPING;
                                            that.nbPages = evidenceWithTemp.evidenceTempDataDto.nbPages;
                                            that.evidenceToCrop = evidenceWithTemp;

                                        }
                                    }
                                })

                            } else {
                                that.numberToUpload = that.checkMandatoryEvidencesLeftToUploaded(); //Check the initial number of mandatory evidences needed to be uploaded
                                that.infoBoxMsg = 'evidences.description'; // Default description
                                that.templateToUse = EvidenceTemplates.EVIDENCES_TEMPLATE_GLOBAL;

                                that.checkButtonActivation();
                            }
                        }
                    } else {
                        // Go to next step
                        console.debug('There is no evidence.');
                        that.signerService.currentSigner.externalSignerStatus = ExternalSignerStatusEnum.Agreements;
                        that.redirectionService.session(that.route, that.sessionId);
                    }

                } else {
                    // If process error
                    // Log the error and redirect
                    console.warn(response?.error?.msg);
                    that.exitError();
                }
            }, function (error) {
                // If communication error
                console.warn(error);
                that.exitError();
            });

        //on hold availability
        this.onHoldAvailability = this.signerService.currentSigner.signingMode !== 'FACE_TO_FACE' && this.sessionService.info.configDto.onHoldAvailability;
        this.onHoldLimitReached = this.onHoldAvailability && this.sessionService.info.onHoldCounter >= this.sessionService.info.configDto.onHoldMaxLimit;

        this.sharedService.on('updateTempData', function (event) {
            //Find right evidence
            for (var i = 0; i < that.evidencesWithTemp.length; i++) {
                var evidence = that.evidencesWithTemp[i];

                //If right evidence
                if (evidence.evidenceDto.extEvidenceId === event.data.evidenceTempData.extEvidenceId) {
                    that.evidencesWithTemp[i].evidenceTempDataDto = event.data.evidenceTempData;
                }
            }
        });

        this.sharedService.on('evidenceVerification', function (event) {
            //Find right evidence
            for (var i = 0; i < that.evidencesWithTemp.length; i++) {
                var evidence = that.evidencesWithTemp[i];

                //If right evidence
                if (evidence.evidenceDto.extEvidenceId === event.data.evidenceId) {
                    if (evidence.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.AFFECTATION) {
                        that.infoBoxMsg = 'affectation.description';
                    } else if (evidence.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.TO_CROP_AND_AFFECTATION) {
                        that.infoBoxMsg = 'cropping.dispatch.description';
                    } else if (evidence.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.TO_CROP) {
                        that.infoBoxMsg = 'cropping.description';
                    }
                    that.templateToUse = EvidenceTemplates.EVIDENCES_TEMPLATE_CROPPING;
                    that.nbPages = evidence.evidenceTempDataDto.nbPages;
                    that.evidenceToCrop = evidence;
                }
            }

        });

        this.sharedService.on('affectTerminated', function () {
            that.redirectionService.session(that.route, that.sessionId);
        });

        this.sharedService.on('updateEvidence', function (event) {
            //For each evidence
            for (var i = 0; i < that.evidencesWithTemp.length; i++) {
                var evidence = that.evidencesWithTemp[i].evidenceDto;

                //If right evidence
                if (evidence.extEvidenceId === event.data.evidenceId) {

                    console.debug('detected a change for evidence ' + event.data.evidenceId);
                    that.evidencesWithTemp[i].evidenceDto = event.data.evidence;
                    that.evidencesWithTemp[i].evidenceDto.externalEvidenceStatus = that.updateEvidence(i);
                }
            }

            //Check the number of mandatory evidences left to upload
            that.numberToUpload = that.checkMandatoryEvidencesLeftToUploaded();
            console.debug('number of mandatory parts to upload: ' + that.numberToUpload);

            that.checkButtonActivation();
        });
    }

    confirmCancel() {
        this.cancelService.confirmCancel(this.route);
    }

    goToNextStep() {
        const that = this;
        if (this.areAllEvidencesReadyToBeAnalysed()) {
            console.debug('analyse');

            this.infoBoxMsg = 'analysis.description';
            this.infoBoxDetails = undefined;
            this.templateToUse = EvidenceTemplates.EVIDENCES_TEMPLATE_ANALYSE;

            this.spinnerService.show('spinner');

            this.http.analyse(this.sessionId, this.signerService.currentSigner.extSignerId).toPromise().then(
                function (response) {
                    if (response?.success) {
                        (response.result as [any]).forEach(evidenceDto => {
                            that.evidencesWithTemp.forEach(evidence => {
                                if (evidence.evidenceDto.extEvidenceId === evidenceDto.extEvidenceId) {
                                    evidence.evidenceDto = evidenceDto;
                                }
                            })
                        })


                        if (that.areAllEvidencesAnalysedSuccessfully()) { // Go straight to the agreement
                            that.spinnerService.hide('spinner');
                            console.debug('analysis success');
                            that.redirectionService.session(that.route, that.sessionId);
                        } else if (that.evidenceAnalysisToValidate()) {
                            that.infoBoxMsg = 'evidence.analysis.maxTryReached';
                            that.loadSlide();
                            that.spinnerService.hide('spinner');
                        } else if (that.evidenceAnalysisError()) { // Go back to the evidence page
                            console.debug('Evidence analysis still in error');

                            that.infoBoxMsg = 'evidence.analysis.error';
                            that.loadSlide();
                            that.spinnerService.hide('spinner');
                        }
                    } else {
                        if (response?.error?.errorCode === 10) {
                            // ErrorMsg.INVALID_INPUT
                            console.warn('Invalid file');
                            that.infoBoxDetails = response?.error?.msg;
                            that.infoBoxMsg = 'evidence.analysis.error.invalidFile';
                        } else {
                            // The process failed because of an unexpected technical error
                            that.infoBoxMsg = 'evidence.analysis.error.technical';
                        }
                        console.warn(response?.error?.msg);
                        that.spinnerService.hide('spinner');
                    }
                }, function (error) {
                    that.infoBoxMsg = 'evidence.analysis.error.technical';
                    that.spinnerService.hide('spinner');
                    console.warn('An error occurred when requesting evidence analysis');
                    console.warn(error);
                });
        } else {
            console.error('All evidences are not ready to be analysed, cannot go to next step');
        }
    };

    isGlobal() {
        return this.templateToUse === EvidenceTemplates.EVIDENCES_TEMPLATE_GLOBAL;
    }

    isCropping() {
        return this.templateToUse === EvidenceTemplates.EVIDENCES_TEMPLATE_CROPPING;
    }

    isAnalyse() {
        return this.templateToUse === EvidenceTemplates.EVIDENCES_TEMPLATE_ANALYSE;
    }

    hold() {
        const that = this;
        var sessionId = this.route.snapshot.params['sessionId'];
        var signerId = this.signerService.currentSigner.extSignerId;

        console.debug('Hold the session');
        // Enable spin
        this.spinnerService.show('spinner');

        this.http.hold(sessionId, signerId).toPromise()
            .then(function (response) {

                //Disable the spin
                that.spinnerService.show('spinner');

                if (response?.success) {
                    console.debug('Hold the session : SUCCESS');
                    var urlOnHold = that.sessionService.info.urlOnHold;
                    if (urlOnHold) {
                        that.redirectionService.exit(that.sessionService.getUrlOnHold());
                    } else {
                        that.redirectionService.hold(that.route, that.sessionId);
                    }

                } else {
                    //Log the error and redirect
                    console.warn(response?.error);
                    that.errorMsg = 'error.unexpected';
                }
            }, that.exitError);
    }

    evidenceAnalysisToValidate() {

        var isEvidenceAnalysisToValidate = false;
        this.evidencesWithTemp.forEach(evidenceWithTemp => {
            //One evidence has an analysis to validate
            if (evidenceWithTemp.evidenceDto!.externalEvidenceStatus === ExternalEvidenceStatus.toValidate) {
                isEvidenceAnalysisToValidate = true;
            }
        })
        console.debug('evidenceAnalysisToValidate return ' + isEvidenceAnalysisToValidate);

        return isEvidenceAnalysisToValidate;
    }

    evidenceAnalysisInProgress() {
        var res = false;

        this.evidencesWithTemp.forEach(evidenceWithTemp => {
            //One evidence has an analysis in progress
            if (evidenceWithTemp.evidenceDto!.externalEvidenceStatus === ExternalEvidenceStatus.processing) {
                res = true;
            }
        })
        console.debug('evidenceAnalysisInProgress return ' + res);
        //No analysis in progress found
        return res;
    }

    private areAllEvidencesReadyToBeAnalysed() {
        if (typeof this.evidencesWithTemp === 'undefined' || this.evidencesWithTemp === null) {
            return true;
        }
        var validStatus = [
            ExternalEvidenceStatus.toProcess,
            ExternalEvidenceStatus.processing
        ];

        var res = true;
        this.evidencesWithTemp.forEach(evidenceWithTemp => {
            if (evidenceWithTemp.evidenceDto.mandatory) {
                console.debug('evidence ' + evidenceWithTemp.evidenceDto.extEvidenceId + ' status : ' + evidenceWithTemp.evidenceDto.externalEvidenceStatus);
                res = res && (validStatus.indexOf(evidenceWithTemp.evidenceDto.externalEvidenceStatus) !== -1);
            }
        })
        console.debug('all evidence ready to be analyzed :' + res);
        return res;
    }

    private areAllEvidencesAnalysedSuccessfully() {

        var res = true;

        this.evidencesWithTemp.forEach(evidenceWithTemp => {
            console.debug('evidence ' + evidenceWithTemp.evidenceDto.extEvidenceId + ' status : ' + evidenceWithTemp.evidenceDto.externalEvidenceStatus + ' mandatory : ' + evidenceWithTemp.evidenceDto.mandatory);
            if (evidenceWithTemp.evidenceDto.externalEvidenceStatus === ExternalEvidenceStatus.completed ||
                (evidenceWithTemp.evidenceDto.externalEvidenceStatus === ExternalEvidenceStatus.toUpload && evidenceWithTemp.evidenceDto.mandatory === false)) {
                res = res && true;
            } else {
                res = res && false;
            }
        })
        console.debug('all evidences analysed successfully return ' + res);
        return res;
    }

    evidenceAnalysisError() {

        var isEvidenceAnalysisError = false;

        this.evidencesWithTemp.forEach(evidenceWithTemp => {
            //One evidence has an analysis in error
            if (evidenceWithTemp.evidenceDto.externalEvidenceStatus === ExternalEvidenceStatus.error) {
                isEvidenceAnalysisError = true;
            }
        })

        console.debug('evidenceAnalysisError return ' + isEvidenceAnalysisError);

        //No analysis in error found
        return isEvidenceAnalysisError;
    }

    private evidenceUploadInProgress() {

        var res = false;

        this.evidencesWithTemp.forEach(evidenceWithTemp => {
            //One evidence has an analysis in progress
            if (evidenceWithTemp.evidenceTempDataDto) {
                if (evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.AFFECTATION || evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.TO_CROP || evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.TO_CROP_AND_AFFECTATION) {
                    res = true;
                }
            }
        })
        console.debug('evidenceUploadInProgress return ' + res);
        //No analysis in progress found
        return res;
    }

    private loadSlide() {
        const that = this;
        // Variable to stack all requests to get evidence image
        var promises: any[] = [];
        this.evidencesWithTemp.forEach(evidenceWithTemp => {
            let evidenceDto = evidenceWithTemp.evidenceDto!;

            if (evidenceDto.externalEvidenceStatus !== ExternalEvidenceStatus.toUpload) {
                if (evidenceDto.evidenceContentType === 'NAMED_PARTS' || evidenceDto.evidenceContentType === 'SINGLE') {
                    evidenceDto.parts!.forEach(part => {
                        // add current promise http to the promises array
                        promises.push(this.http.getRawData(
                            this.sessionId,
                            this.signerService.currentSigner.extSignerId,
                            evidenceDto.extEvidenceId,
                            part.extEvidencePartId
                        ).toPromise().then(blob => {
                            return {
                                data: blob,
                                config: {
                                    part: part, // add part to use it into the resolve function
                                    evidenceDto: evidenceDto // add evidenceDto to use it into the resolve function
                                }
                            }
                        }));
                    })
                }
            }
        });
        //wait for all requests to end
        Promise.all(promises).then(function (responses) {
            responses.forEach(response => {
                var url = window.URL || window.webkitURL;
                var blobUrl = url.createObjectURL(response.data); // pre-load picture as blob , it is required to do this way instead of use src attribut of image because we need to add the token security in http calls
                if (response.config.evidenceDto.evidenceContentType === 'NAMED_PARTS') {
                    that.addSlide(blobUrl, that.translateService.instant('evidences.type.' + response.config.evidenceDto.evidenceType.type) + ' (' + that.translateService.instant('evidences.type.' + response.config.evidenceDto.evidenceType.type + '_' + response.config.part.partName) + ')', response.config.evidenceDto.externalEvidenceStatus);
                } else {
                    that.addSlide(blobUrl, that.translateService.instant('evidences.type.' + response.config.evidenceDto.evidenceType.type), response.config.evidenceDto.externalEvidenceStatus);
                }
            })
            that.startCarousel();
        });

    }

    private checkMandatoryEvidencesLeftToUploaded() {
        //If there are evidences
        if (!typeof this.evidencesWithTemp === undefined || this.evidencesWithTemp !== null) {
            var mandatoryEvidencesNumber = 0;

            //Check of all mandatory and TO_UPLOAD evidences part
            for (var i = 0; i < this.evidencesWithTemp.length; i++) {
                if (this.evidencesWithTemp[i].evidenceDto.mandatory === true && this.evidencesWithTemp[i].evidenceDto.externalEvidenceStatus === ExternalEvidenceStatus.toUpload) {
                    mandatoryEvidencesNumber = mandatoryEvidencesNumber + 1;
                }
            }
            return mandatoryEvidencesNumber;
        }
        return 0;
    }

    /**
     *  Add the slide into a temporary array. It avoid bug where the carousel is lock on the same slide. It occurred when two slides have been added through unshift function, it break the index array in carousel library.
     * @param image, the blob img
     * @param titre, the title of the picture
     * @param status, the status of the analysis for this picture
     */
    private addSlide(image, titre, status) {
        if (status === 'ERROR' || status === 'TO_VALIDATE') {
            this.slidestemp.unshift({
                image: image,
                text: titre,
                status: status
            });
        } else {
            this.slidestemp.push({
                image: image,
                text: titre,
                status: status
            });
        }
    }

    /**
     * Add the slides to carousel
     */
    private startCarousel() {
        this.slidestemp.forEach(slide => {
            this.slides.push(slide);
        })
    }

    private checkButtonActivation() {
        if (this.areAllEvidencesReadyToBeAnalysed()) {
            console.debug('disabled : ' + false);
            this.buttonDisabled = false;
        } else {
            console.debug('disabled : ' + true);
            this.buttonDisabled = true;
        }
    }

    private exitError() {
        this.redirectionService.error(this.route, CustomErrors.unreachableService, this.sessionId);
    }

    private updateEvidence(index) {

        var evidence = this.evidencesWithTemp[index].evidenceDto;

        var isToUpload = false;
        var isToProcess = false;

        for (var i = 0; i < evidence.parts.length; i++) {
            var part = evidence.parts[i];

            isToUpload = isToUpload || (part.externalEvidencePartStatus === ExternalEvidencePartStatus.toUpload);
            isToProcess = isToProcess || (part.externalEvidencePartStatus === ExternalEvidencePartStatus.completed);
        }

        if (isToUpload) {
            return ExternalEvidenceStatus.toUpload;
        } else if (isToProcess) {
            return ExternalEvidenceStatus.toProcess;
        } else {
            return evidence.externalEvidenceStatus;
        }

    }

    openPreview(image) {
        this.currentImage = image;
        let popup = this.modalService.open(ImagePreviewPopupComponent, {
            animation: true
        });
        popup.componentInstance.currentImage = this.currentImage;
    };

    confirmForce() {

        var modalOptions = {
            closeButtonText: this.translateService.instant('evidence.modal.force.cancel'),
            actionButtonText: this.translateService.instant('evidence.modal.force.ok'),
            headerText: this.translateService.instant('evidence.modal.force.header'),
            bodyText: this.translateService.instant('evidence.modal.force.body')
        };
    };


    isForceAllowed() {
        return this.signerService.currentSigner.signingMode === 'FACE_TO_FACE' && this.sessionService.info.configDto.allowForceEvidence;
    };


    nbEvidenceTry() {
        var nbTry = this.sessionService.info.configDto.numberOfEvidenceAnalysis;
        var maxNbTry = 1;
        this.evidencesWithTemp.forEach(evidenceWithTemp => {
            var evidenceDto = evidenceWithTemp.evidenceDto;
            if (evidenceDto.nbAnalysisTry > maxNbTry) {
                maxNbTry = evidenceDto.nbAnalysisTry;
            }
        })
        return nbTry - maxNbTry;
    };

    retryLoadEvidences() {
        const that = this;
        this.spinnerService.show('spinner');

        console.debug('Try to retry evidences !');

        this.http.retryEvidences(this.sessionService.id, this.signerService.currentSigner.extSignerId).toPromise()
            .then(function (response) {
                if (response?.success) {
                    console.debug('Retry done !');

                    that.redirectionService.session(that.route, that.sessionId);
                    that.spinnerService.hide('spinner');
                } else {
                    console.warn(response?.error?.msg);
                    that.spinnerService.hide('spinner');
                }
            }, function (error) {
                console.warn(error);
                that.spinnerService.hide('spinner');
            });
    };
}
